import React from 'react';
import ModernDashboard from './ModernDashboard';

const Dashboard = () => {
    return <ModernDashboard />;
};

export default Dashboard;
